<template>
    <div>filter</div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
    inject: ['mediaQueries'],
    props: {
        name: {
            type: String,
            required: true
        },
        filter: {
            type: Object,
            required: true
        }
    },
    methods: {
        ...mapActions([
            'addFilter',
            'removeFilter',
            'dispatchPreselectedFilters'
        ]),
        toggleFilter(state, key, value, label) {
            if (state) {
                this.addFilter({
                    key,
                    values: [value],
                    preselection: this.mediaQueries.mobile,
                    label: label
                })
            } else {
                this.removeFilter({
                    key,
                    values: [value],
                    preselection: this.mediaQueries.mobile
                })
            }
        }
    }
}
</script>
